import {requestedDateStyles} from "@insite/content-library/Widgets/OrderDetails/OrderDetailsRequestedDate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

requestedDateStyles.titleText = {
    variant: "h3",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        font-size: 15px !important;
    `,
    transform: "uppercase",
    size: 15,
};

requestedDateStyles.description = {
    size: 16,
}

requestedDateStyles.wrapper = {
    css: css`
    ${({ theme }: { theme: BaseTheme }) =>
    breakpointMediaQueries(theme, [
        css`
            display: flex;
            justify-content: space-between;
            padding-right: 20%;
        `,
        css`
            display: flex;
            justify-content: space-between;
            padding-right: 20%;
        `,
        css`
            display: flex;
            justify-content: space-between;
            padding-right: 20%;
        `,
        css`
        `,
        css`
        `,
    ])}
    `,
}